var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// node_modules/dayjs/dayjs.min.js
var require_dayjs_min = __commonJS({
  "node_modules/dayjs/dayjs.min.js"(exports, module) {
    init_esm_shims();
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
    }(exports, function() {
      "use strict";
      var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, m = function(t2, e2, n2) {
        var r2 = String(t2);
        return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
      }, g = { s: m, z: function(t2) {
        var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
        return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
      }, m: function t2(e2, n2) {
        if (e2.date() < n2.date())
          return -t2(n2, e2);
        var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, f), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), f);
        return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
      }, a: function(t2) {
        return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
      }, p: function(t2) {
        return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
      }, u: function(t2) {
        return void 0 === t2;
      } }, v = "en", D = {};
      D[v] = M;
      var p = function(t2) {
        return t2 instanceof _;
      }, S = function t2(e2, n2, r2) {
        var i2;
        if (!e2)
          return v;
        if ("string" == typeof e2) {
          var s2 = e2.toLowerCase();
          D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
          var u2 = e2.split("-");
          if (!i2 && u2.length > 1)
            return t2(u2[0]);
        } else {
          var a2 = e2.name;
          D[a2] = e2, i2 = a2;
        }
        return !r2 && i2 && (v = i2), i2 || !r2 && v;
      }, w = function(t2, e2) {
        if (p(t2))
          return t2.clone();
        var n2 = "object" == typeof e2 ? e2 : {};
        return n2.date = t2, n2.args = arguments, new _(n2);
      }, O = g;
      O.l = S, O.i = p, O.w = function(t2, e2) {
        return w(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
      };
      var _ = function() {
        function M2(t2) {
          this.$L = S(t2.locale, null, true), this.parse(t2);
        }
        var m2 = M2.prototype;
        return m2.parse = function(t2) {
          this.$d = function(t3) {
            var e2 = t3.date, n2 = t3.utc;
            if (null === e2)
              return new Date(NaN);
            if (O.u(e2))
              return new Date();
            if (e2 instanceof Date)
              return new Date(e2);
            if ("string" == typeof e2 && !/Z$/i.test(e2)) {
              var r2 = e2.match(l);
              if (r2) {
                var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
              }
            }
            return new Date(e2);
          }(t2), this.$x = t2.x || {}, this.init();
        }, m2.init = function() {
          var t2 = this.$d;
          this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
        }, m2.$utils = function() {
          return O;
        }, m2.isValid = function() {
          return !(this.$d.toString() === $);
        }, m2.isSame = function(t2, e2) {
          var n2 = w(t2);
          return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
        }, m2.isAfter = function(t2, e2) {
          return w(t2) < this.startOf(e2);
        }, m2.isBefore = function(t2, e2) {
          return this.endOf(e2) < w(t2);
        }, m2.$g = function(t2, e2, n2) {
          return O.u(t2) ? this[e2] : this.set(n2, t2);
        }, m2.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, m2.valueOf = function() {
          return this.$d.getTime();
        }, m2.startOf = function(t2, e2) {
          var n2 = this, r2 = !!O.u(e2) || e2, h2 = O.p(t2), $2 = function(t3, e3) {
            var i2 = O.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
            return r2 ? i2 : i2.endOf(a);
          }, l2 = function(t3, e3) {
            return O.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
          }, y2 = this.$W, M3 = this.$M, m3 = this.$D, g2 = "set" + (this.$u ? "UTC" : "");
          switch (h2) {
            case c:
              return r2 ? $2(1, 0) : $2(31, 11);
            case f:
              return r2 ? $2(1, M3) : $2(0, M3 + 1);
            case o:
              var v2 = this.$locale().weekStart || 0, D2 = (y2 < v2 ? y2 + 7 : y2) - v2;
              return $2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
            case a:
            case d:
              return l2(g2 + "Hours", 0);
            case u:
              return l2(g2 + "Minutes", 1);
            case s:
              return l2(g2 + "Seconds", 2);
            case i:
              return l2(g2 + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, m2.endOf = function(t2) {
          return this.startOf(t2, false);
        }, m2.$set = function(t2, e2) {
          var n2, o2 = O.p(t2), h2 = "set" + (this.$u ? "UTC" : ""), $2 = (n2 = {}, n2[a] = h2 + "Date", n2[d] = h2 + "Date", n2[f] = h2 + "Month", n2[c] = h2 + "FullYear", n2[u] = h2 + "Hours", n2[s] = h2 + "Minutes", n2[i] = h2 + "Seconds", n2[r] = h2 + "Milliseconds", n2)[o2], l2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
          if (o2 === f || o2 === c) {
            var y2 = this.clone().set(d, 1);
            y2.$d[$2](l2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
          } else
            $2 && this.$d[$2](l2);
          return this.init(), this;
        }, m2.set = function(t2, e2) {
          return this.clone().$set(t2, e2);
        }, m2.get = function(t2) {
          return this[O.p(t2)]();
        }, m2.add = function(r2, h2) {
          var d2, $2 = this;
          r2 = Number(r2);
          var l2 = O.p(h2), y2 = function(t2) {
            var e2 = w($2);
            return O.w(e2.date(e2.date() + Math.round(t2 * r2)), $2);
          };
          if (l2 === f)
            return this.set(f, this.$M + r2);
          if (l2 === c)
            return this.set(c, this.$y + r2);
          if (l2 === a)
            return y2(1);
          if (l2 === o)
            return y2(7);
          var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[l2] || 1, m3 = this.$d.getTime() + r2 * M3;
          return O.w(m3, this);
        }, m2.subtract = function(t2, e2) {
          return this.add(-1 * t2, e2);
        }, m2.format = function(t2) {
          var e2 = this, n2 = this.$locale();
          if (!this.isValid())
            return n2.invalidDate || $;
          var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = O.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, f2 = n2.months, h2 = function(t3, n3, i3, s3) {
            return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
          }, c2 = function(t3) {
            return O.s(s2 % 12 || 12, t3, "0");
          }, d2 = n2.meridiem || function(t3, e3, n3) {
            var r3 = t3 < 12 ? "AM" : "PM";
            return n3 ? r3.toLowerCase() : r3;
          }, l2 = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a2 + 1, MM: O.s(a2 + 1, 2, "0"), MMM: h2(n2.monthsShort, a2, f2, 3), MMMM: h2(f2, a2), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: h2(n2.weekdaysMin, this.$W, o2, 2), ddd: h2(n2.weekdaysShort, this.$W, o2, 3), dddd: o2[this.$W], H: String(s2), HH: O.s(s2, 2, "0"), h: c2(1), hh: c2(2), a: d2(s2, u2, true), A: d2(s2, u2, false), m: String(u2), mm: O.s(u2, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: i2 };
          return r2.replace(y, function(t3, e3) {
            return e3 || l2[t3] || i2.replace(":", "");
          });
        }, m2.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m2.diff = function(r2, d2, $2) {
          var l2, y2 = O.p(d2), M3 = w(r2), m3 = (M3.utcOffset() - this.utcOffset()) * e, g2 = this - M3, v2 = O.m(this, M3);
          return v2 = (l2 = {}, l2[c] = v2 / 12, l2[f] = v2, l2[h] = v2 / 3, l2[o] = (g2 - m3) / 6048e5, l2[a] = (g2 - m3) / 864e5, l2[u] = g2 / n, l2[s] = g2 / e, l2[i] = g2 / t, l2)[y2] || g2, $2 ? v2 : O.a(v2);
        }, m2.daysInMonth = function() {
          return this.endOf(f).$D;
        }, m2.$locale = function() {
          return D[this.$L];
        }, m2.locale = function(t2, e2) {
          if (!t2)
            return this.$L;
          var n2 = this.clone(), r2 = S(t2, e2, true);
          return r2 && (n2.$L = r2), n2;
        }, m2.clone = function() {
          return O.w(this.$d, this);
        }, m2.toDate = function() {
          return new Date(this.valueOf());
        }, m2.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, m2.toISOString = function() {
          return this.$d.toISOString();
        }, m2.toString = function() {
          return this.$d.toUTCString();
        }, M2;
      }(), T = _.prototype;
      return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function(t2) {
        T[t2[1]] = function(e2) {
          return this.$g(e2, t2[0], t2[1]);
        };
      }), w.extend = function(t2, e2) {
        return t2.$i || (t2(e2, _, w), t2.$i = true), w;
      }, w.locale = S, w.isDayjs = p, w.unix = function(t2) {
        return w(1e3 * t2);
      }, w.en = D[v], w.Ls = D, w.p = {}, w;
    });
  }
});

// src/index.ts
init_esm_shims();

// src/polish.ts
init_esm_shims();
var polishDiacriticsMap = {
  \u0105: "a",
  \u0107: "c",
  \u0119: "e",
  \u0142: "l",
  \u0144: "n",
  \u00F3: "o",
  \u015B: "s",
  \u017A: "z",
  \u017C: "z",
  \u0104: "A",
  \u0106: "C",
  \u0118: "E",
  \u0141: "L",
  \u0143: "N",
  \u00D3: "O",
  \u015A: "S",
  \u0179: "Z",
  \u017B: "Z"
};
var replacePolishDiacritics = (text) => text.replace(/[ąćęłńóśźż]/gi, (m) => polishDiacriticsMap[m]);
var getPolishNumberConjugation = (value, forms) => {
  if (value === 1)
    return forms[0];
  if (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20)) {
    return forms[1];
  }
  return forms[2];
};

// src/administrativeDivisions.ts
init_esm_shims();
var voivodeships = [
  { key: "dolnoslaskie", name: "Dolno\u015Bl\u0105skie" },
  { key: "kujawsko-pomorskie", name: "Kujawsko-pomorskie" },
  { key: "lubelskie", name: "Lubelskie" },
  { key: "lubuskie", name: "Lubuskie" },
  { key: "lodzkie", name: "\u0141\xF3dzkie" },
  { key: "malopolskie", name: "Ma\u0142opolskie" },
  { key: "mazowieckie", name: "Mazowieckie" },
  { key: "opolskie", name: "Opolskie" },
  { key: "podkarpackie", name: "Podkarpackie" },
  { key: "podlaskie", name: "Podlaskie" },
  { key: "pomorskie", name: "Pomorskie" },
  { key: "slaskie", name: "\u015Al\u0105skie" },
  { key: "swietokrzyskie", name: "\u015Awi\u0119tokrzyskie" },
  { key: "warminsko-mazurskie", name: "Warmi\u0144sko-mazurskie" },
  { key: "wielkopolskie", name: "Wielkopolskie" },
  { key: "zachodniopomorskie", name: "Zachodniopomorskie" }
];
var districts = [
  { key: "aleksandrowski", name: "aleksandrowski" },
  { key: "augustowski", name: "augustowski" },
  { key: "bartoszycki", name: "bartoszycki" },
  { key: "belchatowski", name: "be\u0142chatowski" },
  { key: "bedzinski", name: "b\u0119dzi\u0144ski" },
  { key: "bialski", name: "bialski" },
  { key: "BialaPodlaska", name: "Bia\u0142a Podlaska" },
  { key: "bialobrzeski", name: "bia\u0142obrzeski" },
  { key: "bialogardzki", name: "bia\u0142ogardzki" },
  { key: "bialostocki", name: "bia\u0142ostocki" },
  { key: "Bialystok", name: "Bia\u0142ystok" },
  { key: "bielski", name: "bielski" },
  { key: "BielskoBiala", name: "Bielsko-Bia\u0142a" },
  { key: "bierunskoLedzinski", name: "bieru\u0144sko-l\u0119dzi\u0144ski" },
  { key: "bieszczadzki", name: "bieszczadzki" },
  { key: "bilgorajski", name: "bi\u0142gorajski" },
  { key: "bochenski", name: "boche\u0144ski" },
  { key: "boleslawiecki", name: "boles\u0142awiecki" },
  { key: "braniewski", name: "braniewski" },
  { key: "brodnicki", name: "brodnicki" },
  { key: "brzeski", name: "brzeski" },
  { key: "brzezinski", name: "brzezi\u0144ski" },
  { key: "brzozowski", name: "brzozowski" },
  { key: "buski", name: "buski" },
  { key: "bydgoski", name: "bydgoski" },
  { key: "Bydgoszcz", name: "Bydgoszcz" },
  { key: "Bytom", name: "Bytom" },
  { key: "bytowski", name: "bytowski" },
  { key: "Chelm", name: "Che\u0142m" },
  { key: "chelminski", name: "che\u0142mi\u0144ski" },
  { key: "chelmski", name: "che\u0142mski" },
  { key: "chodzieski", name: "chodzieski" },
  { key: "chojnicki", name: "chojnicki" },
  { key: "Chorzow", name: "Chorz\xF3w" },
  { key: "choszczenski", name: "choszcze\u0144ski" },
  { key: "chrzanowski", name: "chrzanowski" },
  { key: "ciechanowski", name: "ciechanowski" },
  { key: "cieszynski", name: "cieszy\u0144ski" },
  { key: "czarnkowskoTrzcianecki", name: "czarnkowsko-trzcianecki" },
  { key: "Czestochowa", name: "Cz\u0119stochowa" },
  { key: "czestochowski", name: "cz\u0119stochowski" },
  { key: "czluchowski", name: "cz\u0142uchowski" },
  { key: "DabrowaGornicza", name: "D\u0105browa G\xF3rnicza" },
  { key: "dabrowski", name: "d\u0105browski" },
  { key: "debicki", name: "d\u0119bicki" },
  { key: "drawski", name: "drawski" },
  { key: "dzialdowski", name: "dzia\u0142dowski" },
  { key: "dzierzoniowski", name: "dzier\u017Coniowski" },
  { key: "Elblag", name: "Elbl\u0105g" },
  { key: "elblaski", name: "elbl\u0105ski" },
  { key: "elcki", name: "e\u0142cki" },
  { key: "garwolinski", name: "garwoli\u0144ski" },
  { key: "Gdansk", name: "Gda\u0144sk" },
  { key: "gdanski", name: "gda\u0144ski" },
  { key: "Gdynia", name: "Gdynia" },
  { key: "gizycki", name: "gi\u017Cycki" },
  { key: "Gliwice", name: "Gliwice" },
  { key: "gliwicki", name: "gliwicki" },
  { key: "glogowski", name: "g\u0142ogowski" },
  { key: "glubczycki", name: "g\u0142ubczycki" },
  { key: "gnieznienski", name: "gnie\u017Anie\u0144ski" },
  { key: "goleniowski", name: "goleniowski" },
  { key: "golubskoDobrzynski", name: "golubsko-dobrzy\u0144ski" },
  { key: "goldapski", name: "go\u0142dapski" },
  { key: "gorlicki", name: "gorlicki" },
  { key: "gorzowski", name: "gorzowski" },
  { key: "GorzowWielkopolski", name: "Gorz\xF3w Wielkopolski" },
  { key: "gostyninski", name: "gostyni\u0144ski" },
  { key: "gostynski", name: "gosty\u0144ski" },
  { key: "gorowski", name: "g\xF3rowski" },
  { key: "grajewski", name: "grajewski" },
  { key: "grodziski", name: "grodziski" },
  { key: "grojecki", name: "gr\xF3jecki" },
  { key: "Grudziadz", name: "Grudzi\u0105dz" },
  { key: "grudziadzki", name: "grudzi\u0105dzki" },
  { key: "gryficki", name: "gryficki" },
  { key: "gryfinski", name: "gryfi\u0144ski" },
  { key: "hajnowski", name: "hajnowski" },
  { key: "hrubieszowski", name: "hrubieszowski" },
  { key: "ilawski", name: "i\u0142awski" },
  { key: "inowroclawski", name: "inowroc\u0142awski" },
  { key: "janowski", name: "janowski" },
  { key: "jarocinski", name: "jaroci\u0144ski" },
  { key: "jaroslawski", name: "jaros\u0142awski" },
  { key: "jasielski", name: "jasielski" },
  { key: "JastrzebieZdroj", name: "Jastrz\u0119bie-Zdr\xF3j" },
  { key: "jaworski", name: "jaworski" },
  { key: "Jaworzno", name: "Jaworzno" },
  { key: "JeleniaGora", name: "Jelenia G\xF3ra" },
  { key: "jeleniogorski", name: "jeleniog\xF3rski" },
  { key: "jedrzejowski", name: "j\u0119drzejowski" },
  { key: "kaliski", name: "kaliski" },
  { key: "Kalisz", name: "Kalisz" },
  { key: "kamiennogorski", name: "kamiennog\xF3rski" },
  { key: "kamienski", name: "kamie\u0144ski" },
  { key: "kartuski", name: "kartuski" },
  { key: "Katowice", name: "Katowice" },
  { key: "kazimierski", name: "kazimierski" },
  { key: "kedzierzynskoKozielski", name: "k\u0119dzierzy\u0144sko-kozielski" },
  { key: "kepinski", name: "k\u0119pi\u0144ski" },
  { key: "ketrzynski", name: "k\u0119trzy\u0144ski" },
  { key: "Kielce", name: "Kielce" },
  { key: "kielecki", name: "kielecki" },
  { key: "kluczborski", name: "kluczborski" },
  { key: "klobucki", name: "k\u0142obucki" },
  { key: "klodzki", name: "k\u0142odzki" },
  { key: "kolbuszowski", name: "kolbuszowski" },
  { key: "kolnenski", name: "kolne\u0144ski" },
  { key: "kolski", name: "kolski" },
  { key: "kolobrzeski", name: "ko\u0142obrzeski" },
  { key: "konecki", name: "konecki" },
  { key: "Konin", name: "Konin" },
  { key: "koninski", name: "koni\u0144ski" },
  { key: "Koszalin", name: "Koszalin" },
  { key: "koszalinski", name: "koszali\u0144ski" },
  { key: "koscianski", name: "ko\u015Bcia\u0144ski" },
  { key: "koscierski", name: "ko\u015Bcierski" },
  { key: "kozienicki", name: "kozienicki" },
  { key: "krakowski", name: "krakowski" },
  { key: "Krakow", name: "Krak\xF3w" },
  { key: "krapkowicki", name: "krapkowicki" },
  { key: "krasnostawski", name: "krasnostawski" },
  { key: "krasnicki", name: "kra\u015Bnicki" },
  { key: "Krosno", name: "Krosno" },
  { key: "krosnienski", name: "kro\u015Bnie\u0144ski" },
  { key: "krotoszynski", name: "krotoszy\u0144ski" },
  { key: "kutnowski", name: "kutnowski" },
  { key: "kwidzynski", name: "kwidzy\u0144ski" },
  { key: "legionowski", name: "legionowski" },
  { key: "Legnica", name: "Legnica" },
  { key: "legnicki", name: "legnicki" },
  { key: "leski", name: "leski" },
  { key: "leszczynski", name: "leszczy\u0144ski" },
  { key: "Leszno", name: "Leszno" },
  { key: "lezajski", name: "le\u017Cajski" },
  { key: "leborski", name: "l\u0119borski" },
  { key: "lidzbarski", name: "lidzbarski" },
  { key: "limanowski", name: "limanowski" },
  { key: "lipnowski", name: "lipnowski" },
  { key: "lipski", name: "lipski" },
  { key: "lubaczowski", name: "lubaczowski" },
  { key: "lubanski", name: "luba\u0144ski" },
  { key: "lubartowski", name: "lubartowski" },
  { key: "lubelski", name: "lubelski" },
  { key: "lubinski", name: "lubi\u0144ski" },
  { key: "Lublin", name: "Lublin" },
  { key: "lubliniecki", name: "lubliniecki" },
  { key: "lwowecki", name: "lw\xF3wecki" },
  { key: "lancucki", name: "\u0142a\u0144cucki" },
  { key: "laski", name: "\u0142aski" },
  { key: "leczycki", name: "\u0142\u0119czycki" },
  { key: "leczynski", name: "\u0142\u0119czy\u0144ski" },
  { key: "lobeski", name: "\u0142obeski" },
  { key: "lomza", name: "\u0141om\u017Ca" },
  { key: "lomzynski", name: "\u0142om\u017Cy\u0144ski" },
  { key: "losicki", name: "\u0142osicki" },
  { key: "lowicki", name: "\u0142owicki" },
  { key: "lodzki wschodni", name: "\u0142\xF3dzki wschodni" },
  { key: "lodz", name: "\u0141\xF3d\u017A" },
  { key: "lukowski", name: "\u0142ukowski" },
  { key: "makowski", name: "makowski" },
  { key: "malborski", name: "malborski" },
  { key: "miechowski", name: "miechowski" },
  { key: "mielecki", name: "mielecki" },
  { key: "miedzychodzki", name: "mi\u0119dzychodzki" },
  { key: "miedzyrzecki", name: "mi\u0119dzyrzecki" },
  { key: "mikolowski", name: "miko\u0142owski" },
  { key: "milicki", name: "milicki" },
  { key: "minski", name: "mi\u0144ski" },
  { key: "mlawski", name: "m\u0142awski" },
  { key: "mogilenski", name: "mogile\u0144ski" },
  { key: "moniecki", name: "moniecki" },
  { key: "mragowski", name: "mr\u0105gowski" },
  { key: "Myslowice", name: "Mys\u0142owice" },
  { key: "myszkowski", name: "myszkowski" },
  { key: "myslenicki", name: "my\u015Blenicki" },
  { key: "mysliborski", name: "my\u015Bliborski" },
  { key: "nakielski", name: "nakielski" },
  { key: "namyslowski", name: "namys\u0142owski" },
  { key: "nidzicki", name: "nidzicki" },
  { key: "nizanski", name: "ni\u017Ca\u0144ski" },
  { key: "nowodworski", name: "nowodworski" },
  { key: "nowomiejski", name: "nowomiejski" },
  { key: "nowosadecki", name: "nowos\u0105decki" },
  { key: "nowosolski", name: "nowosolski" },
  { key: "nowotarski", name: "nowotarski" },
  { key: "nowotomyski", name: "nowotomyski" },
  { key: "NowySacz", name: "Nowy S\u0105cz" },
  { key: "nyski", name: "nyski" },
  { key: "obornicki", name: "obornicki" },
  { key: "olecki", name: "olecki" },
  { key: "oleski", name: "oleski" },
  { key: "olesnicki", name: "ole\u015Bnicki" },
  { key: "olkuski", name: "olkuski" },
  { key: "Olsztyn", name: "Olsztyn" },
  { key: "olsztynski", name: "olszty\u0144ski" },
  { key: "olawski", name: "o\u0142awski" },
  { key: "opatowski", name: "opatowski" },
  { key: "opoczynski", name: "opoczy\u0144ski" },
  { key: "Opole", name: "Opole" },
  { key: "opolski", name: "opolski" },
  { key: "ostrolecki", name: "ostro\u0142\u0119cki" },
  { key: "Ostroleka", name: "Ostro\u0142\u0119ka" },
  { key: "ostrowiecki", name: "ostrowiecki" },
  { key: "ostrowski", name: "ostrowski" },
  { key: "ostrodzki", name: "ostr\xF3dzki" },
  { key: "ostrzeszowski", name: "ostrzeszowski" },
  { key: "oswiecimski", name: "o\u015Bwi\u0119cimski" },
  { key: "otwocki", name: "otwocki" },
  { key: "pabianicki", name: "pabianicki" },
  { key: "pajeczanski", name: "paj\u0119cza\u0144ski" },
  { key: "parczewski", name: "parczewski" },
  { key: "piaseczynski", name: "piaseczy\u0144ski" },
  { key: "PiekarySlaskie", name: "Piekary \u015Al\u0105skie" },
  { key: "pilski", name: "pilski" },
  { key: "pinczowski", name: "pi\u0144czowski" },
  { key: "piotrkowski", name: "piotrkowski" },
  { key: "PiotrkowTrybunalski", name: "Piotrk\xF3w Trybunalski" },
  { key: "piski", name: "piski" },
  { key: "pleszewski", name: "pleszewski" },
  { key: "Plock", name: "P\u0142ock" },
  { key: "plocki", name: "p\u0142ocki" },
  { key: "plonski", name: "p\u0142o\u0144ski" },
  { key: "poddebicki", name: "podd\u0119bicki" },
  { key: "policki", name: "policki" },
  { key: "polkowicki", name: "polkowicki" },
  { key: "Poznan", name: "Pozna\u0144" },
  { key: "poznanski", name: "pozna\u0144ski" },
  { key: "proszowicki", name: "proszowicki" },
  { key: "prudnicki", name: "prudnicki" },
  { key: "pruszkowski", name: "pruszkowski" },
  { key: "przasnyski", name: "przasnyski" },
  { key: "przemyski", name: "przemyski" },
  { key: "Przemysl", name: "Przemy\u015Bl" },
  { key: "przeworski", name: "przeworski" },
  { key: "przysuski", name: "przysuski" },
  { key: "pszczynski", name: "pszczy\u0144ski" },
  { key: "pucki", name: "pucki" },
  { key: "pulawski", name: "pu\u0142awski" },
  { key: "pultuski", name: "pu\u0142tuski" },
  { key: "pyrzycki", name: "pyrzycki" },
  { key: "raciborski", name: "raciborski" },
  { key: "Radom", name: "Radom" },
  { key: "radomski", name: "radomski" },
  { key: "radomszczanski", name: "radomszcza\u0144ski" },
  { key: "radziejowski", name: "radziejowski" },
  { key: "radzynski", name: "radzy\u0144ski" },
  { key: "rawicki", name: "rawicki" },
  { key: "rawski", name: "rawski" },
  { key: "ropczyckoSedziszowski", name: "ropczycko-s\u0119dziszowski" },
  { key: "RudaSlaska", name: "Ruda \u015Al\u0105ska" },
  { key: "rybnicki", name: "rybnicki" },
  { key: "Rybnik", name: "Rybnik" },
  { key: "rycki", name: "rycki" },
  { key: "rypinski", name: "rypi\u0144ski" },
  { key: "rzeszowski", name: "rzeszowski" },
  { key: "Rzeszow", name: "Rzesz\xF3w" },
  { key: "sandomierski", name: "sandomierski" },
  { key: "sanocki", name: "sanocki" },
  { key: "sejnenski", name: "sejne\u0144ski" },
  { key: "sepolenski", name: "s\u0119pole\u0144ski" },
  { key: "Siedlce", name: "Siedlce" },
  { key: "siedlecki", name: "siedlecki" },
  { key: "Siemianowice slaskie", name: "Siemianowice \u015Al\u0105skie" },
  { key: "siemiatycki", name: "siemiatycki" },
  { key: "sieradzki", name: "sieradzki" },
  { key: "sierpecki", name: "sierpecki" },
  { key: "skarzyski", name: "skar\u017Cyski" },
  { key: "Skierniewice", name: "Skierniewice" },
  { key: "skierniewicki", name: "skierniewicki" },
  { key: "slawienski", name: "s\u0142awie\u0144ski" },
  { key: "slubicki", name: "s\u0142ubicki" },
  { key: "slupecki", name: "s\u0142upecki" },
  { key: "Slupsk", name: "S\u0142upsk" },
  { key: "slupski", name: "s\u0142upski" },
  { key: "sochaczewski", name: "sochaczewski" },
  { key: "sokolowski", name: "soko\u0142owski" },
  { key: "sokolski", name: "sok\xF3lski" },
  { key: "Sopot", name: "Sopot" },
  { key: "Sosnowiec", name: "Sosnowiec" },
  { key: "stalowowolski", name: "stalowowolski" },
  { key: "starachowicki", name: "starachowicki" },
  { key: "stargardzki", name: "stargardzki" },
  { key: "starogardzki", name: "starogardzki" },
  { key: "staszowski", name: "staszowski" },
  { key: "strzelecki", name: "strzelecki" },
  { key: "strzeleckoDrezdenecki", name: "strzelecko-drezdenecki" },
  { key: "strzelinski", name: "strzeli\u0144ski" },
  { key: "strzyzowski", name: "strzy\u017Cowski" },
  { key: "sulecinski", name: "sul\u0119ci\u0144ski" },
  { key: "suski", name: "suski" },
  { key: "suwalski", name: "suwalski" },
  { key: "Suwalki", name: "Suwa\u0142ki" },
  { key: "szamotulski", name: "szamotulski" },
  { key: "Szczecin", name: "Szczecin" },
  { key: "szczecinecki", name: "szczecinecki" },
  { key: "szczycienski", name: "szczycie\u0144ski" },
  { key: "sztumski", name: "sztumski" },
  { key: "szydlowiecki", name: "szyd\u0142owiecki" },
  { key: "sredzki", name: "\u015Bredzki" },
  { key: "sremski", name: "\u015Bremski" },
  { key: "swidnicki", name: "\u015Bwidnicki" },
  { key: "swidwinski", name: "\u015Bwidwi\u0144ski" },
  { key: "swiebodzinski", name: "\u015Bwiebodzi\u0144ski" },
  { key: "swiecki", name: "\u015Bwiecki" },
  { key: "swietochlowice", name: "\u015Awi\u0119toch\u0142owice" },
  { key: "swinoujscie", name: "\u015Awinouj\u015Bcie" },
  { key: "Tarnobrzeg", name: "Tarnobrzeg" },
  { key: "tarnobrzeski", name: "tarnobrzeski" },
  { key: "tarnogorski", name: "tarnog\xF3rski" },
  { key: "tarnowski", name: "tarnowski" },
  { key: "Tarnow", name: "Tarn\xF3w" },
  { key: "tatrzanski", name: "tatrza\u0144ski" },
  { key: "tczewski", name: "tczewski" },
  { key: "tomaszowski", name: "tomaszowski" },
  { key: "Torun", name: "Toru\u0144" },
  { key: "torunski", name: "toru\u0144ski" },
  { key: "trzebnicki", name: "trzebnicki" },
  { key: "tucholski", name: "tucholski" },
  { key: "turecki", name: "turecki" },
  { key: "Tychy", name: "Tychy" },
  { key: "wadowicki", name: "wadowicki" },
  { key: "Walbrzych", name: "Wa\u0142brzych" },
  { key: "walbrzyski", name: "wa\u0142brzyski" },
  { key: "walecki", name: "wa\u0142ecki" },
  { key: "Warszawa", name: "Warszawa" },
  { key: "mazowieckie", name: "mazowieckie" },
  { key: "warszawskiZachodni", name: "warszawski zachodni" },
  { key: "wabrzeski", name: "w\u0105brzeski" },
  { key: "wagrowiecki", name: "w\u0105growiecki" },
  { key: "wejherowski", name: "wejherowski" },
  { key: "wegorzewski", name: "w\u0119gorzewski" },
  { key: "wegrowski", name: "w\u0119growski" },
  { key: "wielicki", name: "wielicki" },
  { key: "wielunski", name: "wielu\u0144ski" },
  { key: "wieruszowski", name: "wieruszowski" },
  { key: "Wloclawek", name: "W\u0142oc\u0142awek" },
  { key: "wloclawski", name: "w\u0142oc\u0142awski" },
  { key: "wlodawski", name: "w\u0142odawski" },
  { key: "wloszczowski", name: "w\u0142oszczowski" },
  { key: "wodzislawski", name: "wodzis\u0142awski" },
  { key: "wolsztynski", name: "wolszty\u0144ski" },
  { key: "wolominski", name: "wo\u0142omi\u0144ski" },
  { key: "wolowski", name: "wo\u0142owski" },
  { key: "Wroclaw", name: "Wroc\u0142aw" },
  { key: "wroclawski", name: "wroc\u0142awski" },
  { key: "wrzesinski", name: "wrzesi\u0144ski" },
  { key: "wschowski", name: "wschowski" },
  { key: "wysokomazowiecki", name: "wysokomazowiecki" },
  { key: "wyszkowski", name: "wyszkowski" },
  { key: "Zabrze", name: "Zabrze" },
  { key: "zambrowski", name: "zambrowski" },
  { key: "zamojski", name: "zamojski" },
  { key: "Zamosc", name: "Zamo\u015B\u0107" },
  { key: "zawiercianski", name: "zawiercia\u0144ski" },
  { key: "zabkowicki", name: "z\u0105bkowicki" },
  { key: "zdunskowolski", name: "zdu\u0144skowolski" },
  { key: "zgierski", name: "zgierski" },
  { key: "zgorzelecki", name: "zgorzelecki" },
  { key: "ZielonaGora", name: "Zielona G\xF3ra" },
  { key: "zielonogorski", name: "zielonog\xF3rski" },
  { key: "zlotoryjski", name: "z\u0142otoryjski" },
  { key: "zlotowski", name: "z\u0142otowski" },
  { key: "zwolenski", name: "zwole\u0144ski" },
  { key: "zaganski", name: "\u017Caga\u0144ski" },
  { key: "zarski", name: "\u017Carski" },
  { key: "zninski", name: "\u017Cni\u0144ski" },
  { key: "zory", name: "\u017Bory" },
  { key: "zurominski", name: "\u017Curomi\u0144ski" },
  { key: "zyrardowski", name: "\u017Cyrardowski" },
  { key: "zywiecki", name: "\u017Cywiecki" }
];

// src/capitalize.ts
init_esm_shims();
var capitalize = (input) => `${input.charAt(0).toUpperCase()}${input.slice(1)}`;

// src/citizenships.ts
init_esm_shims();
var citizenships = [
  {
    value: "AF",
    label: "Afganistan"
  },
  {
    value: "AX",
    label: "Wyspy Alandzkie"
  },
  {
    value: "AL",
    label: "Albania"
  },
  {
    value: "DZ",
    label: "Algieria"
  },
  {
    value: "AS",
    label: "Samoa Ameryka\u0144skie"
  },
  {
    value: "AD",
    label: "Andora"
  },
  {
    value: "AO",
    label: "Angola"
  },
  {
    value: "AI",
    label: "Anguilla"
  },
  {
    value: "AQ",
    label: "Antarktyda"
  },
  {
    value: "AG",
    label: "Antigua i Barbuda"
  },
  {
    value: "AR",
    label: "Argentyna"
  },
  {
    value: "AM",
    label: "Armenia"
  },
  {
    value: "AW",
    label: "Aruba"
  },
  {
    value: "AU",
    label: "Australia"
  },
  {
    value: "AT",
    label: "Austria"
  },
  {
    value: "AZ",
    label: "Azerbejd\u017Can"
  },
  {
    value: "BS",
    label: "Bahamy"
  },
  {
    value: "BH",
    label: "Bahrajn"
  },
  {
    value: "BD",
    label: "Bangladesz"
  },
  {
    value: "BB",
    label: "Barbados"
  },
  {
    value: "BY",
    label: "Bia\u0142oru\u015B"
  },
  {
    value: "BE",
    label: "Belgia"
  },
  {
    value: "BZ",
    label: "Belize"
  },
  {
    value: "BJ",
    label: "Benin"
  },
  {
    value: "BM",
    label: "Bermudy"
  },
  {
    value: "BT",
    label: "Bhutan"
  },
  {
    value: "BO",
    label: "Boliwia, Wielonarodowe Pa\u0144stwo"
  },
  {
    value: "BQ",
    label: "Bonaire, Sint Eustatius i Saba"
  },
  {
    value: "BA",
    label: "Bo\u015Bnia i Hercegowina"
  },
  {
    value: "BW",
    label: "Botswana"
  },
  {
    value: "BV",
    label: "Wyspa Bouveta"
  },
  {
    value: "BR",
    label: "Brazylia"
  },
  {
    value: "IO",
    label: "Brytyjskie Terytorium Oceanu Indyjskiego"
  },
  {
    value: "BN",
    label: "BruneiDarussalam"
  },
  {
    value: "BG",
    label: "Bu\u0142garia"
  },
  {
    value: "BF",
    label: "BurkinaFaso"
  },
  {
    value: "BI",
    label: "Burundi"
  },
  {
    value: "KH",
    label: "Kambod\u017Ca"
  },
  {
    value: "CM",
    label: "Kamerun"
  },
  {
    value: "CA",
    label: "Kanada"
  },
  {
    value: "CV",
    label: "Wyspy Zielonego Przyl\u0105dka"
  },
  {
    value: "KY",
    label: "Kajmany"
  },
  {
    value: "CF",
    label: "Republika \u015Arodkowoafryka\u0144ska"
  },
  {
    value: "TD",
    label: "Czad"
  },
  {
    value: "CL",
    label: "Chile"
  },
  {
    value: "CN",
    label: "Chiny"
  },
  {
    value: "CX",
    label: "Wyspa Bo\u017Cego Narodzenia"
  },
  {
    value: "CC",
    label: "Wyspy Kokosowe (Keelinga)"
  },
  {
    value: "CO",
    label: "Kolumbia"
  },
  {
    value: "KM",
    label: "Komory"
  },
  {
    value: "CG",
    label: "Kongo"
  },
  {
    value: "CD",
    label: "Kongo, Demokratyczna Republika"
  },
  {
    value: "CK",
    label: "Wyspy Cooka"
  },
  {
    value: "CR",
    label: "Kostaryka"
  },
  {
    value: "CI",
    label: "Wybrze\u017Ce Ko\u015Bci S\u0142oniowej"
  },
  {
    value: "HR",
    label: "Chorwacja"
  },
  {
    value: "CU",
    label: "Kuba"
  },
  {
    value: "CW",
    label: "Cura\xE7ao"
  },
  {
    value: "CY",
    label: "Cypr"
  },
  {
    value: "CZ",
    label: "Republika Czeska"
  },
  {
    value: "DK",
    label: "Dania"
  },
  {
    value: "DJ",
    label: "D\u017Cibuti"
  },
  {
    value: "DM",
    label: "Dominika"
  },
  {
    value: "DO",
    label: "Republika Dominikany"
  },
  {
    value: "EC",
    label: "Ekwador"
  },
  {
    value: "EG",
    label: "Egipt"
  },
  {
    value: "SV",
    label: "Salwador"
  },
  {
    value: "GQ",
    label: "Gwinea R\xF3wnikowa"
  },
  {
    value: "ER",
    label: "Erytrea"
  },
  {
    value: "EE",
    label: "Estonia"
  },
  {
    value: "ET",
    label: "Etiopia"
  },
  {
    value: "FK",
    label: "Falklandy (Malwiny)"
  },
  {
    value: "FO",
    label: "Wyspy Owcze"
  },
  {
    value: "FJ",
    label: "Fid\u017Ci"
  },
  {
    value: "FI",
    label: "Finlandia"
  },
  {
    value: "FR",
    label: "Francja"
  },
  {
    value: "GF",
    label: "Gujana Francuska"
  },
  {
    value: "PF",
    label: "Polinezja Francuska"
  },
  {
    value: "TF",
    label: "Francuskie Terytoria Po\u0142udniowe"
  },
  {
    value: "GA",
    label: "Gabon"
  },
  {
    value: "GM",
    label: "Gambia"
  },
  {
    value: "GE",
    label: "Gruzja"
  },
  {
    value: "DE",
    label: "Niemcy"
  },
  {
    value: "GH",
    label: "Ghana"
  },
  {
    value: "GI",
    label: "Gibraltar"
  },
  {
    value: "GR",
    label: "Grecja"
  },
  {
    value: "GL",
    label: "Grenlandia"
  },
  {
    value: "GD",
    label: "Grenada"
  },
  {
    value: "GP",
    label: "Gwadelupa"
  },
  {
    value: "GU",
    label: "Guam"
  },
  {
    value: "GT",
    label: "Gwatemala"
  },
  {
    value: "GG",
    label: "Guernsey"
  },
  {
    value: "GN",
    label: "Gwinea"
  },
  {
    value: "GW",
    label: "Gwinea Bissau"
  },
  {
    value: "GY",
    label: "Gujana"
  },
  {
    value: "HT",
    label: "Haiti"
  },
  {
    value: "HM",
    label: "Wyspy Heard i Wyspy McDonalda"
  },
  {
    value: "VA",
    label: "Stolica Apostolska (Pa\u0144stwo Watyka\u0144skie)"
  },
  {
    value: "HN",
    label: "Honduras"
  },
  {
    value: "HK",
    label: "Hongkong"
  },
  {
    value: "HU",
    label: "W\u0119gry"
  },
  {
    value: "IS",
    label: "Islandia"
  },
  {
    value: "IN",
    label: "Indie"
  },
  {
    value: "ID",
    label: "Indonezja"
  },
  {
    value: "IR",
    label: "Iran (Islamska Republika"
  },
  {
    value: "IQ",
    label: "Irak"
  },
  {
    value: "IE",
    label: "Irlandia"
  },
  {
    value: "IM",
    label: "Wyspa Man"
  },
  {
    value: "IL",
    label: "Izrael"
  },
  {
    value: "IT",
    label: "W\u0142ochy"
  },
  {
    value: "JM",
    label: "Jamajka"
  },
  {
    value: "JP",
    label: "Japonia"
  },
  {
    value: "JE",
    label: "Golf"
  },
  {
    value: "JO",
    label: "Jordania"
  },
  {
    value: "KZ",
    label: "Kazachstan"
  },
  {
    value: "KE",
    label: "Kenia"
  },
  {
    value: "KI",
    label: "Kiribati"
  },
  {
    value: "KP",
    label: "Korea\u0144ska Republika Ludowo-Demokratyczna"
  },
  {
    value: "KR",
    label: "Republika Korei"
  },
  {
    value: "KW",
    label: "Kuwejt"
  },
  {
    value: "KG",
    label: "Kirgistan"
  },
  {
    value: "LA",
    label: "Laota\u0144ska Republika Ludowo-Demokratyczna"
  },
  {
    value: "LV",
    label: "\u0141otwa"
  },
  {
    value: "LB",
    label: "Liban"
  },
  {
    value: "LS",
    label: "Lesotho"
  },
  {
    value: "LR",
    label: "Liberia"
  },
  {
    value: "LY",
    label: "Libia"
  },
  {
    value: "LI",
    label: "Liechtenstein"
  },
  {
    value: "LT",
    label: "Litwa"
  },
  {
    value: "LU",
    label: "Luksemburg"
  },
  {
    value: "MO",
    label: "Makao"
  },
  {
    value: "MK",
    label: "Macedonia, by\u0142a jugos\u0142owia\u0144ska republika"
  },
  {
    value: "MG",
    label: "Madagaskar"
  },
  {
    value: "MW",
    label: "Malawi"
  },
  {
    value: "MY",
    label: "Malezja"
  },
  {
    value: "MV",
    label: "Malediwy"
  },
  {
    value: "ML",
    label: "Mali"
  },
  {
    value: "MT",
    label: "Malta"
  },
  {
    value: "MH",
    label: "Wyspy Marshalla"
  },
  {
    value: "MQ",
    label: "Martynika"
  },
  {
    value: "MR",
    label: "Mauretania"
  },
  {
    value: "MU",
    label: "Mauritius"
  },
  {
    value: "YT",
    label: "Majotta"
  },
  {
    value: "MX",
    label: "Meksyk"
  },
  {
    value: "FM",
    label: "Mikronezja, Sfederowane Stany"
  },
  {
    value: "MD",
    label: "Mo\u0142dawia, Republika"
  },
  {
    value: "MC",
    label: "Monako"
  },
  {
    value: "MN",
    label: "Mongolia"
  },
  {
    value: "ME",
    label: "Czarnog\xF3ra"
  },
  {
    value: "MS",
    label: "Montserrat"
  },
  {
    value: "MA",
    label: "Maroko"
  },
  {
    value: "MZ",
    label: "Mozambik"
  },
  {
    value: "MM",
    label: "Myanmar"
  },
  {
    value: "NA",
    label: "Namibia"
  },
  {
    value: "NR",
    label: "Nauru"
  },
  {
    value: "NP",
    label: "Nepal"
  },
  {
    value: "NL",
    label: "Holandia"
  },
  {
    value: "NC",
    label: "Nowa Kaledonia"
  },
  {
    value: "NZ",
    label: "Nowa Zelandia"
  },
  {
    value: "NI",
    label: "Nikaragua"
  },
  {
    value: "NE",
    label: "Niger"
  },
  {
    value: "NG",
    label: "Nigeria"
  },
  {
    value: "NU",
    label: "Niue"
  },
  {
    value: "NF",
    label: "Wyspa Norfolk"
  },
  {
    value: "MP",
    label: "Mariany P\xF3\u0142nocne"
  },
  {
    value: "NO",
    label: "Norwegia"
  },
  {
    value: "OM",
    label: "Oman"
  },
  {
    value: "PK",
    label: "Pakistan"
  },
  {
    value: "PW",
    label: "Palau"
  },
  {
    value: "PS",
    label: "Terytorium Palesty\u0144skie, Okupowane"
  },
  {
    value: "PA",
    label: "Panama"
  },
  {
    value: "PG",
    label: "Papua Nowa Gwinea"
  },
  {
    value: "PY",
    label: "Paragwaj"
  },
  {
    value: "PE",
    label: "Peru"
  },
  {
    value: "PH",
    label: "Filipiny"
  },
  {
    value: "PN",
    label: "Pitcairn"
  },
  {
    value: "PL",
    label: "Polska"
  },
  {
    value: "PT",
    label: "Portugalia"
  },
  {
    value: "PR",
    label: "Portoryko"
  },
  {
    value: "QA",
    label: "Katar"
  },
  {
    value: "RE",
    label: "Reunion"
  },
  {
    value: "RO",
    label: "Rumunia"
  },
  {
    value: "RU",
    label: "Federacja Rosyjska"
  },
  {
    value: "RW",
    label: "Rwanda"
  },
  {
    value: "BL",
    label: "SaintBarth\xE9lemy"
  },
  {
    value: "SH",
    label: "\u015Awi\u0119ta Helena, Wniebowst\u0105pienie i Tristan da Cunha"
  },
  {
    value: "KN",
    label: "Saint Kitts i Nevis"
  },
  {
    value: "LC",
    label: "\u015Awi\u0119ta Lucia"
  },
  {
    value: "MF",
    label: "Saint Martin (cz\u0119\u015B\u0107 francuska)"
  },
  {
    value: "PM",
    label: "Saint-Pierre i Miquelon"
  },
  {
    value: "VC",
    label: "Saint Vincent i Grenadyny"
  },
  {
    value: "WS",
    label: "Samoa"
  },
  {
    value: "SM",
    label: "SanMarino"
  },
  {
    value: "ST",
    label: "Wyspy \u015Awi\u0119tego Tomasza i Ksi\u0105\u017C\u0119ca"
  },
  {
    value: "SA",
    label: "Arabia Saudyjska"
  },
  {
    value: "SN",
    label: "Senegal"
  },
  {
    value: "RS",
    label: "Serbia"
  },
  {
    value: "SC",
    label: "Seszele"
  },
  {
    value: "SL",
    label: "SierraLeone"
  },
  {
    value: "SG",
    label: "Singapur"
  },
  {
    value: "SX",
    label: "Sint Maarten (cz\u0119\u015B\u0107 holenderska)"
  },
  {
    value: "SK",
    label: "S\u0142owacja"
  },
  {
    value: "SI",
    label: "S\u0142owenia"
  },
  {
    value: "SB",
    label: "Wyspy Salomona"
  },
  {
    value: "SO",
    label: "Somalia"
  },
  {
    value: "ZA",
    label: "Afryka Po\u0142udniowa"
  },
  {
    value: "GS",
    label: "Georgia Po\u0142udniowa i Sandwich Po\u0142udniowy"
  },
  {
    value: "SS",
    label: "Po\u0142udniowy Sudan"
  },
  {
    value: "ES",
    label: "Hiszpania"
  },
  {
    value: "LK",
    label: "SriLanka"
  },
  {
    value: "SD",
    label: "Sudan"
  },
  {
    value: "SR",
    label: "Surinam"
  },
  {
    value: "SJ",
    label: "Svalbard i Jan Mayen"
  },
  {
    value: "SZ",
    label: "Suazi"
  },
  {
    value: "SE",
    label: "Szwecja"
  },
  {
    value: "CH",
    label: "Szwajcaria"
  },
  {
    value: "SY",
    label: "Republika Syryjsko-Arabska"
  },
  {
    value: "TW",
    label: "Tajwan, prowincja Chin"
  },
  {
    value: "TJ",
    label: "Tad\u017Cykistan"
  },
  {
    value: "TZ",
    label: "Tanzania, Zjednoczona Republika"
  },
  {
    value: "TH",
    label: "Tajlandia"
  },
  {
    value: "TL",
    label: "Timor Wschodni"
  },
  {
    value: "TG",
    label: "Togo"
  },
  {
    value: "TK",
    label: "Tokelau"
  },
  {
    value: "TO",
    label: "Tonga"
  },
  {
    value: "TT",
    label: "Trynidad i Tobago"
  },
  {
    value: "TN",
    label: "Tunezja"
  },
  {
    value: "TR",
    label: "Turcja"
  },
  {
    value: "TM",
    label: "Turkmenia"
  },
  {
    value: "TC",
    label: "Wyspy Turks i Caicos"
  },
  {
    value: "TV",
    label: "Tuvalu"
  },
  {
    value: "UG",
    label: "Uganda"
  },
  {
    value: "UA",
    label: "Ukraina"
  },
  {
    value: "AE",
    label: "Zjednoczone Emiraty Arabskie"
  },
  {
    value: "GB",
    label: "Zjednoczone Kr\xF3lestwo"
  },
  {
    value: "US",
    label: "Stany Zjednoczone"
  },
  {
    value: "UM",
    label: "Stany Zjednoczone Dalekie Wyspy Mniejsze"
  },
  {
    value: "UY",
    label: "Urugwaj"
  },
  {
    value: "UZ",
    label: "Uzbekistan"
  },
  {
    value: "VU",
    label: "Vanuatu"
  },
  {
    value: "VE",
    label: "Wenezuela, Boliwaria\u0144ska Republika"
  },
  {
    value: "VN",
    label: "Wietnam"
  },
  {
    value: "VG",
    label: "Wyspy Dziewicze, Brytyjskie"
  },
  {
    value: "VI",
    label: "Wyspy Dziewicze Stan\xF3w Zjednoczonych"
  },
  {
    value: "WF",
    label: "Wallis i Futuna"
  },
  {
    value: "EH",
    label: "Sahara Zachodnia"
  },
  {
    value: "YE",
    label: "Jemen"
  },
  {
    value: "ZM",
    label: "Zambia"
  },
  {
    value: "ZW",
    label: "Zimbabwe"
  }
];

// src/nip.ts
init_esm_shims();
var isValidNip = (_nip) => {
  if (!_nip)
    return false;
  const nip = _nip.toString().replace(/[ -]/gi, "");
  if (nip.length !== 10)
    return false;
  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const controlNumber = parseInt(nip.slice(9, 10));
  const sum = weights.map((weight, idx) => parseInt(nip[idx]) * weight).reduce((a, b) => a + b);
  return sum % 11 === controlNumber;
};

// src/outDuplicates.ts
init_esm_shims();
var outDuplicates = ({ by }) => (item, idx, arr) => {
  return arr.findIndex((_item) => by.every((b) => _item[b] === item[b])) === idx;
};

// src/pesel.ts
init_esm_shims();
var import_dayjs = __toESM(require_dayjs_min());
var isValidPesel = (pesel) => {
  if (pesel.length !== 11)
    return false;
  const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const controlNumber = parseInt(pesel.slice(10, 11));
  const sum = weight.map((weight2, ind) => parseInt(pesel[ind]) * weight2).reduce((a, b) => a + b);
  return (10 - sum % 10) % 10 === controlNumber;
};
var determineSex = (pesel) => {
  if (!pesel)
    return "M";
  if (pesel.length === 12) {
    const sexNumbers2 = parseInt(pesel.slice(10, 11));
    return sexNumbers2 % 2 === 0 ? "K" : "M";
  }
  const sexNumbers = parseInt(pesel.slice(9, 10));
  return sexNumbers % 2 === 0 ? "K" : "M";
};
var determineBirthday = (pesel) => {
  if (!pesel)
    return "1970-01-01";
  const [yearControl, monthControl, day] = [
    pesel.slice(0, 2),
    pesel.slice(2, 4),
    pesel.slice(4, 6)
  ].map((n) => parseInt(n));
  const month = monthControl % 20;
  const year = 1900 + Math.floor(monthControl / 20) * 100 + yearControl;
  const date = (0, import_dayjs.default)().year(year).month(month - 1).date(day).format("YYYY-MM-DD");
  return date;
};
var determineAge = (pesel, baseDate) => {
  const birthTime = determineBirthday(pesel);
  return (baseDate != null ? baseDate : (0, import_dayjs.default)()).diff(birthTime, "year");
};

// src/sortAlphabetically.ts
init_esm_shims();
var sortAlphabetically = (array, property) => {
  return array.sort((a, b) => a[property].localeCompare(b[property]));
};

// src/duration.ts
init_esm_shims();
var duration = (num, unit) => {
  if (unit.startsWith("millisecond")) {
    return num;
  }
  if (unit.startsWith("second")) {
    return num * 1e3;
  }
  if (unit.startsWith("minute")) {
    return num * 60 * 1e3;
  }
  if (unit.startsWith("hour")) {
    return num * 60 * 60 * 1e3;
  }
  if (unit.startsWith("day")) {
    return num * 60 * 60 * 24 * 1e3;
  }
  throw new Error("no such unit");
};

// src/createTestFunction.ts
init_esm_shims();
var createTestFunction = ({ it, expect }) => {
  const testFunction = (fn, tests) => {
    it(fn.name, () => {
      for (const { input, output } of tests) {
        const result = fn(...input);
        expect(result).toStrictEqual(output);
      }
    });
  };
  return testFunction;
};
export {
  capitalize,
  citizenships,
  createTestFunction,
  determineAge,
  determineBirthday,
  determineSex,
  districts,
  duration,
  getPolishNumberConjugation,
  isValidNip,
  isValidPesel,
  outDuplicates,
  polishDiacriticsMap,
  replacePolishDiacritics,
  sortAlphabetically,
  voivodeships
};
